module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAASCAYAAACuLnWgAAAAR0lEQVRIS2NkIAF89J7+nwTlcKWMpGgatYTRxuYN0eG8lX81KaGLiJNRS0gJt9E4ISW0GEaDi3bBhWzykSMiRBeuJMXJqCUAQ3FBj7agdfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title.png
// module id = Cb4U
// module chunks = 1